if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form.querySelector("[name=id]")) {
          this.form.querySelector("[name=id]").disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const bufferMap = this.querySelector("script[data-buffer-sellable]");
        if (bufferMap && !evt.bufferChecked) {
          this.limitToBuffer(bufferMap).then((allowed) => {
            if (allowed) this.onSubmitHandler({ preventDefault() {}, bufferChecked: true });
          });
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          if (this.submitButton.id != "ProductSubmitButton-product-quickview") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const is_cart_page =
              document.body.classList.contains("template-cart");
            if (!is_cart_page) {
              this.cart.renderContents(response);
            } else {
              closePopup.hide();
            }
            const shopableModal = document.querySelector("shopable-modal");
            if (shopableModal) {
              shopableModal.classList.remove("show");
              setTimeout(() => {
                shopableModal.remove();
                document.body.classList.remove("modal-open");
              }, 300);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            if (this.bufferNotice) {
              this.handleErrorMessage(this.bufferNotice);
              this.bufferNotice = null;
            }
          });
      }

      // Store buffer: never add more than the sellable quantity rendered by
      // snippets/buffer-stock.liquid, counting what the cart already holds.
      limitToBuffer(bufferMap) {
        const variantId = this.form.querySelector('[name="id"]').value;
        const sellable = JSON.parse(bufferMap.textContent)[variantId];
        if (sellable === undefined) return Promise.resolve(true);
        const message = bufferMap.dataset.limitMessage.replace("[quantity]", sellable);
        const quantityInput = this.form.querySelector('[name="quantity"]');
        const requested = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        return fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const inCart = cart.items
              .filter((item) => String(item.variant_id) === variantId)
              .reduce((total, item) => total + item.quantity, 0);
            const room = sellable - inCart;
            if (room < 1) {
              this.handleErrorMessage(message);
              return false;
            }
            if (requested > room) {
              quantityInput.value = room;
              this.bufferNotice = message;
            }
            return true;
          })
          .catch(() => true);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
